import CloseIcon from "@mui/icons-material/Close";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
import { Modal } from "@mui/material";
import PropTypes from "prop-types";

function FilePreview(props) {
  const { open, onClose, fileName, file } = props;

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{ display: "flex", overflow: "auto", backdropFilter: "blur(8px)" }}
    >
      <div className="w-full sm:w-[500px] h-full sm:h-fit bg-white m-auto sm:rounded-2xl overflow-hidden">
        <div className="border-bottom-1 flex items-center justify-between">
          <div className="w-12 h-12" />
          <p>{fileName}</p>
          <button className="w-12 h-12" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <div className="flex flex-col h-[calc(100vh-48px)] sm:h-fit sm:max-h-[calc(100vh-70px)] overflow-auto p-3 bg-[#c8c9c9]">
          <img src={file} width="100%" alt="file" />
        </div>
      </div>
    </Modal>
  );
}

FilePreview.propTypes = {
  fileName: PropTypes.string,
  onClose: PropTypes.func,
  file: PropTypes.instanceOf(File),
  open: PropTypes.bool,
};

export default FilePreview;
